import styled from "styled-components";

export const Header = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  background-color: #fff;
`;
export const HeaderContainer = styled.div`
  padding: 0 18px;
  width: 100%;
  max-width: 780px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #fff;
`;
